import { render, staticRenderFns } from "./UsersPermissionManager.vue?vue&type=template&id=2eb97f32&"
import script from "./UsersPermissionManager.vue?vue&type=script&lang=ts&"
export * from "./UsersPermissionManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports